// @ts-nocheck
// Admin page shell: header + tab navigation + the active tab's content.
// Gated by useAdmin; non-admins get a polite "access denied" panel
// instead of the page contents.

import { useState } from "react";
import { useAdmin } from "../../lib/useAdmin";
import { useAuth } from "../../lib/useAuth";
import { AuthModal } from "../AuthModal";
import { adminStyles } from "./adminStyles";
import { AdminOverview } from "./AdminOverview";
import { AdminInvitations } from "./AdminInvitations";
import { AdminReviews } from "./AdminReviews";
import { AdminUsers } from "./AdminUsers";
import { AdminPurchases } from "./AdminPurchases";
import { AdminSimulation } from "./AdminSimulation";

type TabId =
  | "overview"
  | "invitations"
  | "reviews"
  | "users"
  | "purchases"
  | "simulation"
  | "circles"
  | "compliance";

const TABS: Array<{ id: TabId; label: string; coming?: boolean }> = [
  { id: "overview", label: "סקירה" },
  { id: "invitations", label: "הזמנות" },
  { id: "reviews", label: "משובים" },
  { id: "users", label: "משתמשים" },
  { id: "purchases", label: "רכישות" },
  { id: "simulation", label: "סימולציה" },
  { id: "circles", label: "חוגי קריאה", coming: true },
  { id: "compliance", label: "בקרה", coming: true },
];

export function AdminPage() {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, loading: adminLoading } = useAdmin();
  const [tab, setTab] = useState<TabId>("overview");
  const [authOpen, setAuthOpen] = useState(false);

  const goHome = () => {
    window.history.pushState({}, "", "/");
    window.location.reload();
  };

  if (authLoading || adminLoading) {
    return (
      <div className="adm-bg">
        <style dangerouslySetInnerHTML={{ __html: adminStyles }} />
        <div className="adm-loading">טוען…</div>
      </div>
    );
  }

  // Not signed in → prompt for sign-in
  if (!user) {
    return (
      <div className="adm-bg">
        <style dangerouslySetInnerHTML={{ __html: adminStyles }} />
        <div className="adm-denied">
          <h2>פאנל ניהול</h2>
          <p>נדרשת התחברות כדי לראות את הפאנל. רק חשבונות מורשים יקבלו גישה.</p>
          <button
            className="adm-btn"
            style={{ marginTop: 16 }}
            onClick={() => setAuthOpen(true)}
          >
            להתחברות
          </button>
          <div style={{ marginTop: 12 }}>
            <button className="adm-back" onClick={goHome}>
              חזרה לאפליקציה
            </button>
          </div>
        </div>
        {authOpen && <AuthModal onClose={() => setAuthOpen(false)} />}
      </div>
    );
  }

  // Signed in but not flagged admin
  if (!isAdmin) {
    return (
      <div className="adm-bg">
        <style dangerouslySetInnerHTML={{ __html: adminStyles }} />
        <div className="adm-denied">
          <h2>אין הרשאת ניהול</h2>
          <p>
            החשבון <span className="mono">{user.email}</span> אינו מסומן כאדמין.
            לאדמין מורשה — להפעיל מ‑SQL Editor:
          </p>
          <pre style={{
            textAlign: "left",
            direction: "ltr",
            background: "#F3EDE3",
            padding: 10,
            borderRadius: 8,
            marginTop: 12,
            fontSize: 12,
            overflowX: "auto",
          }}>
{`update public.profiles
set is_admin = true
where email = '${user.email}';`}
          </pre>
          <button className="adm-back" style={{ marginTop: 14 }} onClick={goHome}>
            חזרה לאפליקציה
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="adm-bg">
      <style dangerouslySetInnerHTML={{ __html: adminStyles }} />
      <div className="adm-shell">
        <div className="adm-head">
          <div>
            <div className="adm-title">פאנל ניהול</div>
            <div className="adm-subtitle">
              מחובר/ת כ‑<span className="mono">{user.email}</span>
            </div>
          </div>
          <button className="adm-back" onClick={goHome}>
            ← חזרה לאפליקציה
          </button>
        </div>

        <div className="adm-tabs">
          {TABS.map((t) => (
            <button
              key={t.id}
              className={`adm-tab${tab === t.id ? " active" : ""}${t.coming ? " coming" : ""}`}
              onClick={() => !t.coming && setTab(t.id)}
              disabled={t.coming}
            >
              {t.label}
            </button>
          ))}
        </div>

        {tab === "overview" && <AdminOverview />}
        {tab === "invitations" && <AdminInvitations />}
        {tab === "reviews" && <AdminReviews />}
        {tab === "users" && <AdminUsers />}
        {tab === "purchases" && <AdminPurchases />}
        {tab === "simulation" && <AdminSimulation />}
        {tab === "circles" && <ComingSoon label="חוגי קריאה" />}
        {tab === "compliance" && <ComingSoon label="בקרה" />}
      </div>
    </div>
  );
}

function ComingSoon({ label }: { label: string }) {
  return (
    <div className="adm-card">
      <div className="adm-empty">
        מודול "{label}" יבנה בשלב מאוחר יותר.
      </div>
    </div>
  );
}
